import React from "react";

// redux
import { connect } from "react-redux";

// themes
import LayoutTheme1 from './Themes/LayoutTheme1'

function Layout(props) {
    // props
    const {
        globalAppTheme,
        children
    } = props

    return (
        <React.Fragment>
            {
                globalAppTheme === "theme1" &&
                <LayoutTheme1
                    children={children}
                />
            }
        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

export default connect(getDataFromStore, null)(Layout);